<template>
    <StoryblokComponent v-if="referencedBlok" :blok="referencedBlok" global-component />
</template>
<script setup>
const props = defineProps({ blok: Object });
const referencedBlok = computed(() => props.blok.reference[0]?.content?.global?.[0]); 
</script>